import StatusCrossOut from './StatusCrossOut';
import StatusDefault, { type StatusProps } from './StatusDefault';
import StatusHalfFilled from './StatusHalfFilled';
import StatusStroke from './StatusStroke';

function Status(props: StatusProps) {
    return <StatusDefault {...props} />;
}

export default Object.assign(Status, {
    HalfFilled: StatusHalfFilled,
    Stroke: StatusStroke,
    CrossOut: StatusCrossOut
});
